import { render, staticRenderFns } from "./VisionboardSettingsModal.vue?vue&type=template&id=2d1696ad&"
import script from "./VisionboardSettingsModal.vue?vue&type=script&lang=js&"
export * from "./VisionboardSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./VisionboardSettingsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports